import React from "react";

export const Cursor = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 19 19"
    >
      <path
        d="M12.6 14.913l3.063-10.945a.619.619 0 00-.762-.761L3.96 6.27a.619.619 0 00-.174 1.114l3.051 2.018-3.589 3.59a.62.62 0 000 .88l1.751 1.752a.618.618 0 00.44.18.618.618 0 00.44-.18l3.589-3.59 2.017 3.051a.618.618 0 001.114-.173z"
        clipRule="evenodd"
      />
    </svg>
  );
};
